import React, { useEffect, useState } from "react";
import axios from "axios";
import API_BASE_URL from "../config";
import "./EmployeeMeetings.css";
import { toast } from "react-toastify";


const EmployeeMeetings = ({ employee }) => {
  const [meetings, setMeetings] = useState([]);
  const [loading, setLoading] = useState(true);

  // Cannot Join modal state
  const [cannotJoinModal, setCannotJoinModal] = useState({ show: false, meetingId: null, reason: "" });

  const fetchMeetings = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_BASE_URL}/api/meetings/employee/${employee._id}`);
      setMeetings(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMeetings();
  }, [employee]);

  const getMeetingStatus = (scheduledFor) => {
    const now = new Date();
    const meetingTime = new Date(scheduledFor);
    const hoursDiff = (meetingTime - now) / (1000 * 60 * 60);
    if (hoursDiff < 0) return "completed";
    if (hoursDiff <= 1) return "upcoming";
    return "scheduled";
  };

  const formatMeetingTime = (scheduledFor) => {
    const date = new Date(scheduledFor);
    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();
    const isTomorrow = new Date(now.setDate(now.getDate() + 1)).toDateString() === date.toDateString();
    if (isToday) return `Today, ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
    if (isTomorrow) return `Tomorrow, ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
    return date.toLocaleString([], { weekday: 'short', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  const handleCannotJoin = (meetingId) => {
    setCannotJoinModal({ show: true, meetingId, reason: "" });
  };

  const submitCannotJoin = async () => {
    if (!cannotJoinModal.reason) return toast.error("Please enter a reason");

    try {
      await axios.post(`${API_BASE_URL}/api/meetings/cannot-join`, {
        meetingId: cannotJoinModal.meetingId,
        employeeId: employee._id,
        reason: cannotJoinModal.reason,
      });
      toast.success("Manager has been notified!");
      setCannotJoinModal({ show: false, meetingId: null, reason: "" });
    } catch (err) {
      console.error(err);
      toast.error("Failed to notify manager");
    }
  };

  if (loading) return <p>Loading your meetings...</p>;

  return (
    <div className="meetingsContainerWrapper">
      <div className="meetingsMainContainer">
        <div className="meetingsHeaderSection">
          <h2 className="meetingsMainTitle">📅 My Meetings</h2>
          <div className="meetingsSummary">{meetings.length} total</div>
        </div>

        {meetings.length === 0 ? (
          <p>No meetings scheduled</p>
        ) : (
          <div className="meetingsGridLayout">
            {meetings.map((meeting) => {
              const status = getMeetingStatus(meeting.scheduledFor);
              return (
                <div key={meeting._id} className={`meetingCardItem meetingCardStatus-${status}`}>
                  <div className="meetingCardHeader">
                    <span>{status.charAt(0).toUpperCase() + status.slice(1)}</span>
                    <span>{formatMeetingTime(meeting.scheduledFor)}</span>
                  </div>
                  <div className="meetingContentSection">
                    <h3>{meeting.title}</h3>
                    <p>{meeting.description || "No description provided"}</p>
                  </div>
                  <div className="meetingActionSection">
                    <a href={meeting.meetingLink} target="_blank" rel="noopener noreferrer">Join Meeting</a>
                    <button onClick={() => handleCannotJoin(meeting._id)} style={{ marginLeft: "10px" }}>Cannot Join</button>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Cannot Join Modal */}
        {cannotJoinModal.show && (
          <div className="modalOverlay">
            <div className="modalContent">
              <h3>Reason for not joining</h3>
              <textarea
                value={cannotJoinModal.reason}
                onChange={(e) => setCannotJoinModal({ ...cannotJoinModal, reason: e.target.value })}
                placeholder="Enter reason..."
              />
              <div style={{ marginTop: "10px" }}>
                <button onClick={submitCannotJoin}>Submit</button>
                <button onClick={() => setCannotJoinModal({ show: false, meetingId: null, reason: "" })}>Cancel</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmployeeMeetings;
